/* eslint-disable @nx/enforce-module-boundaries */
import { DeleteIcon, Download, Move, Share } from '@mybridge/icons';
import { CopyIcon } from '@mybridge/icons/Copy';
import { LinkIcon } from '@mybridge/icons/Link';
import { RenameIcon } from '@mybridge/icons/Rename';
import {
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Portal,
} from '@mybridge/ui';
import { useToast } from '@mybridge/ui/hooks';
import { useContext, useMemo } from 'react';
import { isFile } from 'v4/components/utils';
import { copyTextToClipboard } from 'v4/lib/commons';
import { DiskContext } from '../../context';
import { useDispatch } from 'react-redux';
import { useDownloadFile } from 'v4/components/hooks/useDownloadFile';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const SharedDiskUserItemMenu = ({ children, ...props }) => {
  const { revokeSharedDiskUserDisc, revokeSharedDiskUser } =
    useContext(DiskContext);
    const { t } = useTranslator();

  const items = useMemo(
    () => [
      {
        title: t('myDisk.removeMe') || 'Remove Me',
        Icon: DeleteIcon,
        props: { onClick: revokeSharedDiskUserDisc?.onOpen },
      },
    ],
    []
  );
  
  return (
    <Menu>
      <MenuButton>{children}</MenuButton>
      <Portal>
        <MenuList zIndex="2">
          {items?.map((item, index) =>
            item.type === 'divider' ? (
              <MenuDivider key={index} />
            ) : (
              <MenuItem
                key={index}
                {...(item.props ?? {})}
                icon={<item.Icon width={20} height={20} />}
              >
                {item.title}
              </MenuItem>
            )
          )}
        </MenuList>
      </Portal>
    </Menu>
  );
};
